"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

// helpers pour les tlTable
ngModule.factory("tlTableUtils", function (itTableRegistry, $interpolate) {
  function _getNewTableSelection(selectedElement, list, idAttributeName) {
    if (idAttributeName === undefined) {
      idAttributeName = 'id';
    }
    var foundItem = null;
    if (selectedElement != null) {
      _.each(list, function (c) {
        if (c[idAttributeName] === selectedElement[idAttributeName]) {
          foundItem = c;
        }
      });
    }
    return foundItem;
  }
  return {
    /**
     * workaround sur les problème d'affichage lors de resize du contenu de la page qui impacte le tl-table
     * @param listOrElementName les nom (chaine) de la list/element a watcher pour générer un resize
     */
    fixResize: function fixResize($scope, listOrElementName) {
      $scope.$watch(listOrElementName, function () {
        // fix resize issue on table selection/resize
        _.delay(function () {
          $scope.$broadcast("$resize");
          $scope.$apply();
        }, 200);
      });
    },
    /**
     * après une mise à jour d'une liste, renvoie le nouvel element qui correspond à la selection en ce basant sur un attribut 'id'
     * @param selectedElement l'éléement du tableau préalablement selectionné (ex: $scope.selected)
     * @param list la liste des donnes du tableau
     * @param {string} [idAttributeName=id] si non fourni alors 'id'
     * @return le nouvel element selectionné, null si aucun
     */
    getNewTableSelection: function getNewTableSelection(selectedElement, list, idAttributeName) {
      return _getNewTableSelection(selectedElement, list, idAttributeName);
    },
    /**
     * unwatch et vide le tableau
     * @param watchers un array des "unwatchers" créé via watchers.push($scope.$watcher(...))
     */
    unbindWatchers: function unbindWatchers(watchers) {
      var length = watchers.length;
      for (var i = 0; i < length; i++) {
        // unbind
        watchers[i]();
      }
      while (watchers.length) {
        watchers.pop();
      }
    },
    /**
     * prochain element de la source de la table (en tenant bien compte de la visualisation actuelle avec le tri)
     * @param tableId champs id de la configuration de la table
     * @param id valeur de l'identifiant
     * @param idAttributeName par défaut 'id'
     * @returns {null|*}
     */
    getNextTableElement: function getNextTableElement(tableId, id, idAttributeName) {
      if (idAttributeName === undefined) {
        idAttributeName = 'id';
      }
      var tableRendererCtrl = itTableRegistry.getController(tableId);
      if (!tableRendererCtrl) {
        console.error('Impossible de trouver le controller de la table d\'id : ' + tableId + " pour trouver l'id : " + id);
      }
      var data = tableRendererCtrl.getDataSource();
      for (var i = 1; i < data.length; i++) {
        if (data[i - 1][idAttributeName] === id) {
          return data[i];
        }
      }
      return null;
    },
    /**
     * met à jour la selection avec la derniere selectionner ou si non présente la next
     * @param $scope
     * @param selectedAttribute
     * @param nextAttribute
     * @param list la liste où l'on veut retrouver l'élement suivant
     * @param idAttributeName
     */
    updateSelectedWithSelectedOrNextTableElement: function updateSelectedWithSelectedOrNextTableElement($scope, selectedAttribute, nextAttribute, list, idAttributeName) {
      var newSelection;
      if (idAttributeName === undefined) {
        idAttributeName = 'id';
      }
      newSelection = _getNewTableSelection($scope[selectedAttribute], list, idAttributeName);

      // selectionne l'element suivant si la selection n'est plus présente
      if (newSelection == null && $scope[nextAttribute] != null) {
        newSelection = _.find(list, function (m) {
          return m[idAttributeName] === $scope[nextAttribute][idAttributeName];
        });
        if (newSelection == null) {
          console.log('non trouvé', $scope[nextAttribute], list);
        }
      }
      $scope[nextAttribute] = null;
      $scope[selectedAttribute] = newSelection;
    },
    /**
     * pour gérer le formattage en fonction du filtre de la colonne de référence (nécessaire pour la date)
     * subtotalTemplate: '<span>TOTAL : {{displaySubtotalRefValue(model)}}</span>'
     *
     */
    displaySubtotalRefValue: function displaySubtotalRefValue(model) {
      var expression = '{{model.__refValue__';
      if (model.__refValueFilter__) {
        expression += '|' + model.__refValueFilter__;
      }
      expression += '}}';
      return $interpolate(expression)({
        'model': model
      });
    },
    /**
     * ajoute les colonnes du tableau (qui ont un id de défini) au choix d'affichage des colonnes.<br/>
     * Ne gère pour le moment pas les "sous-colonnes"<br/>
     *
     * Vous pouvez ajouter sur les colonne : <br/>
     * columnGroup=false pour ne pas mettre cette colonne dans le colomnGroup automatiquement<br/>
     * columnGroupTitle titre de la colonne dans le columnGroup (pratique par exemple pour une colonne où l'on affiche pas le titre ou un abrégé)<br/>
     * columnGroupVisible : indique si la colonne est cochée (visible) ou non par défaut. Si non précisée, elle est non affichée par défaut.<br/>
     * @param columnGroups
     * @param columns
     */
    updateColumnGroup: function updateColumnGroup(columnGroups, columns) {
      _.each(columns, function (column) {
        if (column.columnGroup !== false && column.id) {
          columnGroups.push({
            id: column.id,
            title: column.columnGroupTitle || column.title,
            columns: [column.id],
            visible: column.columnGroupVisible || false
          });
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/tlTableUtils.js
// module id = 3020
// module chunks = 13